import { items } from './utils/unorderedListItems';

import { Container, ItemDiv, ItemIcon, ItemsDiv, ItemText, WomanDiv } from './styles';

export function PlanBenefits() {
  return (
    <Container>
      <ItemsDiv>
        {items.map((item, index) => (
          <ItemDiv key={index}>
            <ItemIcon src={item.icon} alt='ícone da lista' />

            <ItemText>{item.text}</ItemText>
          </ItemDiv>
        ))}
      </ItemsDiv>

      <WomanDiv />
    </Container>
  );
}
